import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const getAnnouncement = (params) => {
    const { parentId, pathsContext } = params;

    return VerbFetch(`${pathsContext.serverUrl}/announcements/${parentId}`);
};

export const getManyAnnouncements = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/announcements`;
    const url = buildQueryString(rest, baseUrl);

    return VerbFetch(url);
};

export const postAnnouncement = (params) => {
    const { body, pathsContext } = params;
    const urlToPost = `${pathsContext.adminServerUrl}/announcements`;
    const fetchOptions = {
        method: 'POST',
        body
    };

    return VerbFetch(urlToPost, fetchOptions);
};

export const putAnnouncement = (params) => {
    const { parentId, body, pathsContext } = params;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return VerbFetch(`${pathsContext.adminServerUrl}/announcements/${parentId}`, fetchOptions);
};
